module.exports = __webpack_public_path__ + "img/aths.43e7f68.png";